export const UI_TEXT = {
  errors: {
    patches: "패치 목록을 아직 불러오지 못했습니다.",
    summary: "통계 데이터를 아직 불러오지 못했습니다.",
    matches: "최근 전적을 아직 갱신하지 못했습니다.",
    itemBuilds: "아이템 빌드 통계를 아직 갱신하지 못했습니다.",
  },
  loading: {
    server: "서버를 불러오는 중입니다. 잠시만 기다려주세요.",
    retry: "자동 재시도 중입니다.",
    itemBuilds: "아이템 빌드 통계를 불러오는 중...",
  },
  filters: {
    all: "전체",
    ranked: "랭크게임",
    normal: "일반게임",
  },
  tabs: {
    matches: "에키온 최근 전적",
    itemBuilds: "아이템빌드 통계",
    simulator: "에키온 시뮬레이터",
    history: "History",
    notice: "안내사항",
  },
  common: {
    patch: "패치",
    search: "검색",
    nicknameSearch: "닉네임 검색",
    previous: "이전",
    next: "다음",
  },
  summary: {
    title: "에키온 DB",
    statGridLabel: "에키온 패치 랭크 통계",
    rankedGames: "랭크게임 수",
    rankedAvgRank: "랭크 평균 순위",
    rankedWinRate: "랭크 승률",
    rankedAvgRp: "랭크 평균 RP 획득",
    rankedAvgDamage: "랭크 평균 딜량",
    weaponStats: "무기별 통계",
    noWeaponStats: "표시할 무기 통계가 없습니다.",
  },
  matches: {
    tabLabel: "에키온 화면 탭",
    gameTypeFilter: "게임 타입 필터",
    nickname: "닉네임",
    damageInfo: "피해 정보",
    loadoutInfo: "장비 / 특성 / 전술",
    noRecentMatches: "조건에 맞는 최근 전적이 없습니다.",
    recentMatchPage: "최근 경기 페이지",
    pickRate: "픽률",
    winRate: "승률",
    averageRank: "평균 등수",
    averageRp: "평균 RP",
    trait: "특성",
    tactical: "전술",
    totalDamage: "총피해량",
    basicAttack: "기본공격",
    skillAttack: "스킬공격",
    fixedDamage: "고정피해",
    itemDamage: "아이템피해",
    normalRp: "RP - 일반",
    noEquipment: "장비 없음",
  },
  transferFlow: {
    toggleOpen: "아이템 변경 기록 보기",
    toggleClose: "아이템 변경 기록 닫기",
    title: "아이템 변경 기록",
    description: "콘솔 전송 요청을 기반으로 한 기록입니다.",
    empty: "기록된 아이템 변경 기록이 없습니다.",
    groupTitle: "아이템 변경 기록",
    sourceConsole: "콘솔",
  },
  items: {
    noItemBuildStats: "표시할 아이템 빌드 통계가 없습니다.",
    itemBuild: "아이템 빌드",
    countSuffix: "회",
    averageRank: "평균 순위",
    averagePlacement: "평균 등수",
  },
  simulator: {
    equipmentSlots: {
      weapon: "무기",
      armor: "옷",
      head: "모자",
      arm: "팔",
      leg: "다리",
    },
    weapons: {
      deathadder: "데스애더",
      sidewinder: "사이드와인더",
      blackmamba: "블랙맘바",
    },
    passiveDescriptions: {
      deathadder: "데스애더 계열 패시브 설명 입력 예정",
      sidewinder: "사이드와인더 계열 패시브 설명 입력 예정",
      blackmamba: "블랙맘바 계열 패시브 설명 입력 예정",
    },
    skills: {
      q: "독사의 칼날",
      q2: "독사의 칼날 2타",
      w: "뒤집힌 비늘",
      e: "메마른 송곳니",
      r: "VF 폭주",
      passive: "카드모스의 부름",
    },
    notice: "기초 기능 제공 중입니다. 전적/통계 화면 안정화 후 장비 선택과 계산 기능을 확장할 예정입니다.",
    finalStats: "최종 능력치",
    hp: "체력",
    attackPower: "공격력",
    defense: "방어력",
    weaponTypeLabel: "무기 타입 선택",
    equipmentSlotLabel: "장비 슬롯",
    skillIconLabel: "스킬 아이콘",
  },
  history: {
    empty: "표시할 패치 이력이 없습니다.",
    note: "패치 히스토리는 현재 수집된 에키온 변경 사항을 기준으로 표시됩니다. 데이터가 없는 버전은 이후 수집 상태에 따라 추가될 수 있습니다.",
  },
  gameType: {
    ranked: "랭크",
    normal: "일반",
  },
  time: {
    justNow: "방금 전",
    minutesAgoSuffix: "분 전",
    hoursAgoSuffix: "시간 전",
    daysAgoSuffix: "일 전",
  },
};
